import React from "react";
import { ToastContainer, cssTransition } from "react-toastify";
import Icon from "../icons/Icon";
import "./toast.css";

/**
 * ANNA's toast look ("colour tile card"): white card, a tinted tile with the
 * type's icon, an automatic title over the message, a round close button and a
 * thin progress line in the type's colour. Every existing toast.success/error/…
 * call picks it up as is; nothing changes at the call sites.
 */

const LOOKS = {
  success: { icon: "check-circle", title: "All set" },
  error: { icon: "x-circle", title: "That didn’t go through" },
  warning: { icon: "alert-triangle", title: "Heads up" },
  info: { icon: "info", title: "Good to know" },
  default: { icon: "info", title: "Note" },
};

// The library wraps this in .Toastify__toast-icon, which toast.css turns into
// `display: contents`, so the tile and the title become grid cells of the body.
function ToastBadge({ type, isLoading }) {
  const look = LOOKS[type] || LOOKS.default;
  return (
    <>
      <span className="at-tile" aria-hidden="true">
        {isLoading ? <span className="at-spinner" /> : <Icon name={look.icon} size={22} />}
      </span>
      <strong className="at-title">{isLoading ? "Working on it" : look.title}</strong>
    </>
  );
}

function ToastCloseButton({ closeToast }) {
  return (
    <button
      type="button"
      className="at-close"
      aria-label="Dismiss"
      onClick={(e) => {
        e.stopPropagation();
        closeToast(e);
      }}
    >
      <Icon name="x" size={16} strokeWidth={2.2} />
    </button>
  );
}

const annaTransition = cssTransition({
  enter: "at-enter",
  exit: "at-exit",
  collapseDuration: 220,
});

export default function AnnaToastContainer(props) {
  return (
    <ToastContainer
      position="top-right"
      autoClose={4000}
      closeOnClick
      pauseOnFocusLoss
      pauseOnHover
      draggable="touch"
      theme="light"
      icon={ToastBadge}
      closeButton={ToastCloseButton}
      transition={annaTransition}
      {...props}
    />
  );
}
